<button
  class="theme-toggle"
  type="button"
  [attr.aria-label]="accessibleLabel()"
  [title]="accessibleLabel()"
  (click)="cycleTheme()"
>
  <i [class]="'ph ph-' + currentOption().icon" aria-hidden="true"></i>
</button>
